import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../Contexts/LayoutContext';
import { useStoreHook } from '../Hooks/StoreHook';
import DefaultLayout from '../Layouts/DefaultLayout';
import Img from '../Components/Layout/Img';
import { IoIosArrowBack } from 'react-icons/io';
import { ImSpinner8 } from 'react-icons/im';

const FidelityTerms = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { company, loadingCompany, isMobile } = useLayoutContext();
    const { getLinkToHome, loadCompanyInfo } = useStoreHook();


    useEffect(() => {
        if (!company && !loadingCompany) {
            loadCompanyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (company && (!company.fidelity || !company.fidelity.active)) {
            navigate(getLinkToHome());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company, loadingCompany]);

    if (loadingCompany) {
        return (
          <DefaultLayout showHeader={!isMobile}>
              <div className="flex items-center justify-center min-h-[60vh]">
                    <ImSpinner8 className="animate-spin text-4xl text-custom-primary" />
              </div>
          </DefaultLayout>
      );
  }

    if (!company?.fidelity?.active) return null;

    return (
        <DefaultLayout showHeader={!isMobile}>

            <div className="w-full container max-w-[900px] mx-auto flex flex-col gap-6">

                {/* Banner */}
                {company.fidelity.banner_image_url && (
                    <div className="w-full rounded-lg overflow-hidden shadow-sm mt-4 md:mt-2">
                        <Img
                            src={company.fidelity.banner_image_url}
                            alt={company.fidelity.title || t('menu.main.fidelity.label')}
                            className="w-full h-auto object-cover max-h-[300px] md:max-h-[400px]"
                        />
                    </div>
                )}

                {/* Header with Back Button */}
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/programa-de-fidelidade')}
                        className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-600"
                    >
                        <IoIosArrowBack size={24} />
                    </button>
                    <h1 className="text-2xl md:text-3xl font-bold text-shopfood-title">
                        {t('layout.fidelity.terms.title')}
                    </h1>
                </div>

                {/* Terms Content */}
                <div className="bg-white rounded-lg p-6 md:p-8 ring-1 ring-gray-100">
                    <div className="prose prose-sm md:prose-base max-w-none text-gray-600">
                        {company.fidelity.terms ? (
                            <div dangerouslySetInnerHTML={{ __html: company.fidelity.terms }} />
                        ) : (
                            <p>{t('layout.fidelity.terms.not_available')}</p>
                        )}
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
};

export default FidelityTerms;
